import { getSidebarToggleStyles } from '@components/v2/icons/SidebarToggle';
import { makeStyles } from 'tss-react/mui';

export const useDetailsToggleStyles = makeStyles()((theme) => ({
  toggle: getSidebarToggleStyles({
    duration: theme.transitions.duration.shorter,
    easing: theme.transitions.easing.easeInOut,
    isMirrored: true,
  }),
}));
